import React from "react"
import { HashLink } from "react-router-hash-link"

export default React.forwardRef((itemProps, ref) => (
  <HashLink {...itemProps} innerRef={ref} />
))
